import { render, staticRenderFns } from "./CodeBlock.vue?vue&type=template&id=53e1b8ff&scoped=true"
import script from "./CodeBlock.vue?vue&type=script&lang=js"
export * from "./CodeBlock.vue?vue&type=script&lang=js"
import style0 from "./CodeBlock.vue?vue&type=style&index=0&id=53e1b8ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e1b8ff",
  null
  
)

export default component.exports